<template>
  <div class="p-solve">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <SlickCarousel
      className="solve"
      :baseData="currentTabData"
      :textLeft="true"
    />
    <div class="p-block-more">
      <kd-link
        type="primary"
        @click="
          $emit('homeCallback', {
            dwClickName: 'learn_more_smart_plat',
          })
        "
      >
        <KdIcon
          icon="ArrowRightS"
          :size="24"
          fill="currentColor"
          margin="0 0 0 3px"
          leftText="点击咨询，了解更多"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import { solveData } from '@/views/homeV2/config.js';
import SlickCarousel from '@/components/SlickCarousel/index.vue';
import KdIcon from '@/components/KdIcon/index.vue';
export default {
  name: 'solve-component',
  components: { SlickCarousel, KdIcon },
  data() {
    return {
      baseData: solveData,
      currentTabData: solveData.tab0,
    };
  },
};
</script>

<style lang="scss" scoped>
.p-solve {
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  > p {
    text-align: center;
    margin: 100px auto;
  }
}
</style>
